export var PriceAuditType;
(function (PriceAuditType) {
    PriceAuditType[PriceAuditType["CORRECT_PRICE"] = 0] = "CORRECT_PRICE";
    PriceAuditType[PriceAuditType["WRONG_PRICE"] = 1] = "WRONG_PRICE";
    PriceAuditType[PriceAuditType["WITHOUT_PRICE"] = 2] = "WITHOUT_PRICE";
    PriceAuditType[PriceAuditType["ALL_PRICES"] = 3] = "ALL_PRICES";
})(PriceAuditType || (PriceAuditType = {}));
